import React, { useRef, useState } from "react";
import arrowLeft from "../../assets/img/arrow-left.png";
import arrowRight from "../../assets/img/arrow-right.png";
import playSection from "../../assets/img/playIcon.svg";
import "./VideoCarousel.css"; // Optional CSS file for styling
import ReactPlayer from "react-player/vimeo";

import Modal from "react-modal";

Modal.setAppElement("#root");

const arrowButtonStyle = {
  cursor: "pointer",
  width: "35px",
  height: "35px",
};
const arrowButtonStyleM = {
  cursor: "pointer",
  width: "22px",
  height: "22px",
};

const videos = [
  {
    title: "How to send message and documents to your adjuster",
    image: "video_image1.svg",
    // src: "https://player.vimeo.com/video/702177843?h=f698312f3a&autoplay=1&portrait=0&byline=0&title=0"
    src: "https://player.vimeo.com/video/702177843?h=f698312f3a&portrait=0&byline=0&title=0&autoplay=1&dnt=1",
  },
  {
    title: "How to schedule an appraisal",
    image: "video_image2.svg",
    src: "https://player.vimeo.com/video/702177808?h=d91ccb556b&portrait=0&byline=0&title=0&autoplay=1&dnt=1",
  },
  {
    title: "How to check claim status if you are not a UAIC customer",
    image: "video_image3.svg",
    src: "https://player.vimeo.com/video/702177740?h=6a5f753614&portrait=0&byline=0&title=0&autoplay=1&dnt=1",
  },
  {
    title: "How to report a claim",
    image: "video_image4.svg",
    src: "https://player.vimeo.com/video/702177771?h=a8f4844750&portrait=0&byline=0&title=0&autoplay=1&dnt=1",
  },
  {
    title: "How to check the status on an existing claim",
    image: "video_image5.svg",
    src: "https://player.vimeo.com/video/703832189?h=3a30c086d1&portrait=0&byline=0&title=0&autoplay=1&dnt=1",
  },
];

const CARD_WIDTH = 320;
const GAP = 24;

const VideoCarousel = ({ responsiveStatus, showBlueLine }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [defaultVideo, setdefaultVideo] = useState({
    src: "https://player.vimeo.com/video/702177843?h=f698312f3a&portrait=0&byline=0&title=0&autoplay=1&dnt=1",
    title: "How to send message and documents to your adjuster",
  });

  const openModal = (src, title) => {
    setModalIsOpen(true);
    setdefaultVideo({ src, title });
  };
  const closeModal = () => setModalIsOpen(false);

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = CARD_WIDTH + GAP;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className={showBlueLine ? "carousel-bg" : "carousel-bg1"}>
        {responsiveStatus === "isMobile" ||
        responsiveStatus === "isSmallMobile" ? (
          <h2 className="carousel-title-m mb-3">
            <span
              style={{
                borderBottom: showBlueLine ? "2px solid #0E72D6" : "",
                paddingBottom: "3px",
              }}
            >
              We're Here to{" "}
            </span>
            Help!
          </h2>
        ) : (
          <h2 className="carousel-title mb-3">
            We're
            <span
              style={{
                borderBottom: showBlueLine ? "2px solid #0E72D6" : "",
                paddingBottom: "3px",
              }}
            >
              {" "}
              Here to{" "}
            </span>
            Help!
          </h2>
        )}

        <div
          className={`${
            responsiveStatus === "isDesktop"
              ? "carousel-wrapper"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "carousel-wrapper"
              : "carousel-wrapperM"
          }`}
        >
          <img
            style={
              responsiveStatus === "isDesktop"
                ? arrowButtonStyle
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? arrowButtonStyle
                : arrowButtonStyleM
            }
            className="arrows"
            src={arrowLeft}
            onClick={() => scroll("left")}
            alt="arrows"
            tabIndex={0} // Makes it keyboard-focusable
            role="button" // Announces the image as a button to screen readers
            aria-label="Scroll left" // Descriptive label for assistive tech
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault(); // Prevents default scroll on space
                scroll("left");
              }
            }}
          />

          <div
            className={`${
              responsiveStatus === "isDesktop"
                ? "carousel"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "carousel"
                : "carouselM"
            }`}
            ref={scrollRef}
            style={{
              width: `calc(${CARD_WIDTH * 3.5 + GAP * 2.5}px)`,
            }}
          >
            {videos.map((video, index) => (
              <div
                className={
                  responsiveStatus === "isDesktop"
                    ? "container-wrap"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "container-wrap"
                    : "container-wrapM"
                }
              >
                <div className="cards-main-wrap">
                  <div
                    className={
                      responsiveStatus === "isDesktop"
                        ? "card-cover"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "card-cover"
                        : "card-coverM"
                    }
                    onClick={() => openModal(video.src, video.title)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        openModal(video.src, video.title);
                      }
                    }}
                    tabIndex={0} // Makes the div focusable with keyboard
                    role="button" // Accessibility hint for screen readers
                    aria-label={`Play video: ${video.title}`} // Optional accessibility label
                  >
                    {/* <div className="card-cover"> */}
                    <div
                      className={`${
                        responsiveStatus === "isDesktop"
                          ? "img-wrap"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "img-wrap"
                          : "img-wrapM"
                      }`}
                    >
                      <img
                        src={require(`../../assets/img/${video.image}`)}
                        alt={video.title}
                        className="video-image"
                      />
                    </div>
                    <div
                      className={`${
                        responsiveStatus === "isDesktop"
                          ? "card-info-wrap"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "card-info-wrap"
                          : "card-info-wrapM"
                      }`}
                    >
                      <div className="top-heading">Watch Video</div>
                      <div className="text" style={{ fontSize: "11px" }}>
                        {video.title}
                      </div>
                      {/* <span className="icon-wrap"> &lt; </span> */}
                      <span className="icon-wrap">
                        {" "}
                        <img
                          style={{
                            width: "15px",
                            height: "15px",
                            marginTop: "-2px",
                            marginLeft: "3px",
                          }}
                          src={require(`../../assets/img/playIcon.svg`)}
                          alt="play icon"
                        />{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <img
            onClick={() => scroll("right")}
            tabIndex={0} // Make the image focusable via keyboard
            role="button" // Makes it behave like a button for screen readers
            aria-label="Scroll right" // Descriptive label for accessibility
            style={
              responsiveStatus === "isDesktop"
                ? arrowButtonStyle
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? arrowButtonStyle
                : arrowButtonStyleM
            }
            src={arrowRight}
            alt="arrows"
            className="arrows"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault(); // Prevent scroll when pressing space
                scroll("right");
              }
            }}
          />
        </div>
      </div>

      <div>
        {/* <button
        onClick={openModal}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        Watch Video
      </button> */}

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Video Popup"
          style={{
            content: {
              maxWidth: "750px",
              margin: "auto",
              padding: "0",
              borderRadius: "10px",
              overflow: "hidden",
              height: "465px",
              zIndex: 2,
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        >
          <div style={{ position: "relative", height: "100%" }}>
            <button
              className="arrows"
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "0px",
                right: "5px",
                background: "white",
                border: "none",
                fontSize: "25px",
                cursor: "pointer",
                zIndex: 1,
              }}
            >
              &times;
            </button>

            {/* <iframe
            src={defaultVideo}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            title="Vimeo Video"
            
          ></iframe> */}
            <div
              style={{ position: "relative", width: "100%", height: "420px" }}
            >
              <h2
                style={{
                  fontSize: "14px",
                  padding: "10px 10px 5px 10px",
                  fontWeight: 600,
                }}
              >
                {defaultVideo.title}
              </h2>
              <hr style={{ paddingBottom: "0px" }} />
              <iframe
                className="videos-iframe"
                src={defaultVideo.src}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
                title="Vimeo Video"
              ></iframe>

              {/* <video
          src={defaultVideo.src}
          autoPlay
          loop
          muted
          playsInline
          className={
            responsiveStatus === "isDesktop"
              ? "background-iframe"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "background-iframe-tab"
              : "background-iframe-m"
          }
        ></video> */}
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default VideoCarousel;
